import { render, staticRenderFns } from "./zuzhijiagou.vue?vue&type=template&id=e9e63b6e&"
import script from "./zuzhijiagou.vue?vue&type=script&lang=ts&"
export * from "./zuzhijiagou.vue?vue&type=script&lang=ts&"
import style0 from "./zuzhijiagou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports